import React from 'react';
const EdmSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-edm" });
EdmSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-edm sirius-icon-edm-enhance" });
export default EdmSvg;
